import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Spacer from '../components/Spacer';

function Contact() {
  const { t } = useTranslation();
  const iframeRef = useRef(null);

  const handleIframeLoad = () => {
    // Access the iframe and remove the background style
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.style.background = 'none';
      console.log('Background style removed from the iframe!');
    }
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'ContactPage',
            name: 'Contact CV Therapy',
            description: 'Contact CV Therapy for therapy services in Palm Desert, CA',
            url: 'https://cvtherapy.org/contact',
            mainEntity: {
              '@type': 'LocalBusiness',
              name: 'CV Therapy',
              image: 'https://cvtherapy.org/assets/logo.svg',
              address: {
                '@type': 'PostalAddress',
                streetAddress: '41865 Boardwalk Suite 208',
                addressLocality: 'Palm Desert',
                addressRegion: 'CA',
                postalCode: '92211',
                addressCountry: 'US',
              },
              contactPoint: [
                {
                  '@type': 'ContactPoint',
                  telephone: '+1-760-459-5939',
                  contactType: 'customer service',
                  areaServed: 'US',
                  availableLanguage: ['English', 'Spanish'],
                  hoursAvailable: 'Mo,Tu,Th 08:00-17:00; We 08:00-15:00; Sa 10:00-14:00',
                },
                {
                  '@type': 'ContactPoint',
                  telephone: '+1-760-459-5939',
                  contactType: 'fax',
                  areaServed: 'US',
                },
              ],
              openingHoursSpecification: [
                {
                  '@type': 'OpeningHoursSpecification',
                  dayOfWeek: 'Monday',
                  opens: '08:00',
                  closes: '17:00',
                },
                {
                  '@type': 'OpeningHoursSpecification',
                  dayOfWeek: 'Tuesday',
                  opens: '08:00',
                  closes: '17:00',
                },
                {
                  '@type': 'OpeningHoursSpecification',
                  dayOfWeek: 'Wednesday',
                  opens: '08:00',
                  closes: '15:00',
                },
                {
                  '@type': 'OpeningHoursSpecification',
                  dayOfWeek: 'Thursday',
                  opens: '08:00',
                  closes: '17:00',
                },
                {
                  '@type': 'OpeningHoursSpecification',
                  dayOfWeek: 'Saturday',
                  opens: '10:00',
                  closes: '14:00',
                },
              ],
            },
          })}
        </script>
      </Helmet>
      <Spacer />
      <div className="container" style={{ minHeight: 1000 }}>
        <h1 className="display-4 text-center text-primary">{t('contactMe.title')}</h1>
        <div className="row">
          <div className="col-md-3">
            <p className="text-primary">{t('contactMe.final-message')}</p>
            <p className="text-primary mb-4">
              {t('contactMe.phone')}
              <span>
                {' '}
                <a className="text-primary" href="tel:7604595939">
                  {t('phoneNumber')}
                </a>
              </span>
            </p>
            <p className="text-primary mb-4">
              {t('contactMe.fax')}
              <span>
                {' '}
                <span className="text-primary">
                  {t('faxNumber')}
                </span>
              </span>
            </p>
            <p className="text-primary">
              <i>
                {t('contactMe.privacy-p1')}
                <b>
                  {' '}
                  {t('contactMe.privacy-p2')}
                  {' '}
                </b>
                {t('contactMe.privacy-p3')}
              </i>
            </p>
          </div>
          <div className="col-md-9">
            <iframe
              ref={iframeRef}
              src="https://docs.google.com/forms/d/e/1FAIpQLSeYcm2pcuCAWFAdSQFwHaWsghbjM9aDY4bYG7d0p34lzFhVQQ/viewform?embedded=true"
              title="Donation Form"
              width="100%"
              height="1200"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              onLoad={handleIframeLoad}
              style={{ background: 'url(./assets/loading.png) center top no-repeat', backgroundSize: '50px 50px' }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
